// Backend API URLs, keyed by environment. Kept in a dependency-free leaf module
// (imports nothing) so it can never participate in an import cycle. `client.tsx`
// lives in a cycle (client → state/devMock → … → consumers → client), so a
// `const APIURLS` defined there sits in the temporal dead zone whenever a
// module-scope consumer is reached mid-cycle ("Cannot access 'APIURLS' before
// initialization"). A leaf module is always fully initialized before any read.
// `client.tsx` re-exports this for backward compatibility.
export const APIURLS = {
  production: import.meta.env.REACT_APP_API_PRODUCTION_URL || 'not-set',
  staging: import.meta.env.REACT_APP_API_STAGING_URL || 'not-set',
  development: import.meta.env.REACT_APP_API_DEVELOPMENT_URL || 'not-set',
  preview: import.meta.env.REACT_APP_API_PREVIEW_URL || 'not-set',
};
